var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledCollapseArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.76709L5 14.7671L5 2.76709L12.5 8.76709Z",
    fill: "#F3F6F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCollapseArrow);
export default __webpack_public_path__ + "static/media/FilledCollapseArrow.0fefa41766a93ee9d466825b0f60b6e7.svg";
export { ForwardRef as ReactComponent };